import gsap from 'gsap'
import Core from 'smooothy'

export default class ArtworkGallery {
	constructor() {
		this.instances = []
		document.querySelectorAll('[data-artwork-gallery]').forEach(container => {
			const thumbWrapper = container.querySelector('[data-artwork-slider]')
			const focusWrapper = container.querySelector('[data-focus-slider]')
			if (!thumbWrapper || !focusWrapper) return
			this.instances.push(new ArtworkGalleryInstance(container, thumbWrapper, focusWrapper))
		})
	}

	destroy() {
		this.instances.forEach(instance => instance?.destroy?.())
		this.instances = []
	}
}

class ArtworkGalleryInstance {
	constructor(container, thumbWrapper, focusWrapper) {
		this.container = container
		this.abortController = new AbortController()

		this.thumbs = new Core(thumbWrapper, {
			infinite: true,
			snap: true,
			speedDecay: 0.9,
		})

		this.focus = new Core(focusWrapper, {
			infinite: true,
			snap: true,
			lerpFactor: 1,
		})

		this.boundTick = this.#tick.bind(this)
		gsap.ticker.add(this.boundTick)

		this.#createControls()
		this.#disableNativeDrag()
		this.#startAutoplay()
	}

	#tick() {
		const focusActive = this.focus.isDragging || this.focus.isTouching
		const m = focusActive ? this.focus : this.thumbs
		const s = focusActive ? this.thumbs : this.focus

		m.update()
		s.target = m.target
		s.current = m.current
		s.update()
	}

	#createControls() {
		const arrows = [...this.container.querySelectorAll('[data-arrows] > *')]
		const { signal } = this.abortController

		arrows.forEach((arrow, index) => {
			arrow.addEventListener(
				'click',
				() => {
					if (index === 0) this.thumbs.goToPrev()
					else this.thumbs.goToNext()
					this.#resetAutoplay()
				},
				{ signal }
			)
		})
	}

	#disableNativeDrag() {
		const { signal } = this.abortController
		this.container.querySelectorAll('img').forEach(img => img.setAttribute('draggable', 'false'))
		this.thumbs.wrapper.addEventListener('dragstart', e => e.preventDefault(), { signal })
	}

	#startAutoplay() {
		this.autoplayInterval = setInterval(() => this.thumbs.goToNext(), 5000)
	}

	#resetAutoplay() {
		clearInterval(this.autoplayInterval)
		this.#startAutoplay()
	}

	destroy() {
		this.abortController?.abort()
		clearInterval(this.autoplayInterval)
		gsap.ticker.remove(this.boundTick)
		this.thumbs?.destroy?.()
		this.focus?.destroy?.()
	}
}
